import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { Message } from 'element-ui';
import axios from 'axios';
import store from '@/store';
import util from '@/libs/util'; // 进度条

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import config from '@/config';
/**
 * @description 记录和显示错误
 * @param {Error} error 错误对象
 */

function handleError(error) {
  // 添加到日志
  store.dispatch('d2admin/log/push', {
    message: '数据请求异常',
    type: 'danger',
    meta: {
      error: error
    }
  }); // 打印到控制台

  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>');
    console.log(error);
  } // 显示提示


  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
}
/**
 * @description 创建请求实例
 */


function createService(getter) {
  // 创建一个 axios 实例
  var service = axios.create({
    baseURL: '',
    timeout: 60000 * 10 // 请求超时时间

  }); // 请求拦截

  service.interceptors.request.use(function (config) {
    // console.log('store.getters[getter]', store.getters[getter])
    // 获取api地址
    config.baseURL = store.getters[getter];
    var token = util.cookies.get('token');
    config.headers.Authorization = "Bearer ".concat(token); // const ORG_CODE = util.cookies.get('ORG_CODE') || ''
    // console.log('ORG_CODE',ORG_CODE);
    // if (config.params) {
    //   config.params.ORG_CODE = ORG_CODE
    // }
    // if (!config.params && config.method === 'get') {
    //   if (config.url.includes('?')) {
    //     config.url += `&ORG_CODE=${ORG_CODE}`
    //   }
    // }

    return config;
  }, function (error) {
    // 发送失败
    // console.log(error)
    return Promise.reject(error);
  }); // 响应拦截

  service.interceptors.response.use(function (response) {
    // console.log('response data', response.data)
    if (response.data.ErrorInfo.Message) {
      Message.warning(response.data.ErrorInfo.Message);
    }

    if (response.data.ErrorInfo.Status === true) {
      return {
        code: 500,
        data: response.data.Result,
        message: response.data.ErrorInfo.Message
      };
    } else {
      return {
        code: 0,
        data: response.data.Result,
        TotalCount: response.data.TotalCount,
        message: response.data.ErrorInfo.Message
      };
    }
  }, function (error) {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break;

        case 401:
          error.message = '权限过期，请重新登录';
          break;

        case 403:
          error.message = '拒绝访问';
          break;

        case 404:
          error.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ".concat(error.response.config.url);
          break;

        case 408:
          error.message = '网络超时，请检查网络链接';
          break;

        case 500:
          error.message = '服务器内部错误';
          break;

        case 501:
          error.message = '服务未实现';
          break;

        case 502:
          error.message = '网关错误';
          break;

        case 503:
          error.message = '服务不可用';
          break;

        case 504:
          error.message = '网关超时';
          break;

        case 505:
          error.message = 'HTTP版本不受支持';
          break;

        default:
          break;
      }
    }

    handleError(error); // return {}

    throw error;
  });
  return service;
}

function UserCreateService() {
  var baseURL = null;
  var moreUser = process.env.VUE_APP_MORE_API_USER === 'ON';

  if (moreUser) {
    // baseURL = util.cookies.get('userApi')
    // console.log(util.cookies.get('userApi'))
    if (!util.cookies.get('userApi')) {
      var users = process.env.VUE_APP_API_USERS.split(',');
      baseURL = users[0];
    } else {
      baseURL = util.cookies.get('userApi');
    }
  } else {
    baseURL = process.env.VUE_APP_USERAPI;
  } // 创建一个 axios 实例
  // console.log('baseUrl-----', baseURL)


  var service = axios.create({
    baseURL: baseURL,
    timeout: 60000 * 10 // 请求超时时间

  }); // 请求拦截

  service.interceptors.request.use(function (config) {
    var token = util.cookies.get('token');
    config.headers.Authorization = "Bearer ".concat(token); // const ORG_CODE = util.cookies.get('ORG_CODE') || ''
    // console.log('ORG_CODE',ORG_CODE);
    // if (config.params) {
    //   config.params.ORG_CODE = ORG_CODE
    // }
    // if (!config.params && config.method === 'get') {
    //   if (config.url.includes('?')) {
    //     config.url += `&ORG_CODE=${ORG_CODE}`
    //   }
    // }

    return config;
  }, function (error) {
    // 发送失败
    // console.log(error)
    return Promise.reject(error);
  }); // 响应拦截

  service.interceptors.response.use(function (response) {
    // console.log('response data', response.data)
    if (response.data.ErrorInfo.Message) {
      Message.warning(response.data.ErrorInfo.Message);
    }

    if (response.data.ErrorInfo.Status === true) {
      return {
        code: 500,
        data: response.data.Result,
        message: response.data.ErrorInfo.Message
      };
    } else {
      return {
        code: 0,
        data: response.data.Result,
        TotalCount: response.data.TotalCount,
        message: response.data.ErrorInfo.Message
      };
    }
  }, function (error) {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break;

        case 401:
          error.message = '权限过期，请重新登录';
          break;

        case 403:
          error.message = '拒绝访问';
          break;

        case 404:
          error.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ".concat(error.response.config.url);
          break;

        case 408:
          error.message = '网络超时，请检查网络链接';
          break;

        case 500:
          error.message = '服务器内部错误';
          break;

        case 501:
          error.message = '服务未实现';
          break;

        case 502:
          error.message = '网关错误';
          break;

        case 503:
          error.message = '服务不可用';
          break;

        case 504:
          error.message = '网关超时';
          break;

        case 505:
          error.message = 'HTTP版本不受支持';
          break;

        default:
          break;
      }
    }

    handleError(error); // return {}

    throw error;
  });
  return service;
}

export var service = createService('getVUE_APP_API');
export var userService = UserCreateService();